import { connect } from 'react-redux';

import GenderFilter from './GenderFilter';
import { trackRefineSearchClickGender } from '../../../../actions';

const mapDispatchToProps = {
    trackRefineSearchClickGender,
};

export default connect(undefined, mapDispatchToProps)(GenderFilter);
